<template>
  <div v-if="download">
    <div class="bg-white py-5 my-2">
      <h3 class="text-center pb-5 font-bold" v-text="i18n.ranchsync.title"></h3>
      <h4 class="text-center pb-5" v-text="i18n.ranchsync.subtitle"></h4>
      <div class="flex items-start justify-around">
        <ranchsync-button
          :data="ranchsync"
          v-for="ranchsync in ranchsyncs"
          :key="ranchsync.id"
        ></ranchsync-button>
      </div>
    </div>

    <div class="bg-white py-5 my-2">
      <h3 class="text-center pb-5 font-bold" v-text="i18n.web.title"></h3>
      <p class="text-center truncate">
        <a
          class="text-black underline font-mono text-sm"
          target="_blank"
          :href="download.web"
          v-text="download.web"
        />
      </p>
    </div>

    <div class="bg-white py-5 my-2">
      <h3 class="text-center pb-5 font-bold" v-text="i18n.ftp.title"></h3>
      <div class="">
        <div class="flex pb-3">
          <div class="pr-3 w-1/2">
            <simple-label :label="i18n.ftp.login"></simple-label>
            <text-copier
              :message="download.ftp.login"
              class="text-sm"
            ></text-copier>
          </div>
          <div class="pl-3 w-1/2">
            <simple-label :label="i18n.ftp.password"></simple-label>
            <text-copier
              :message="download.ftp.password"
              class="text-sm"
            ></text-copier>
          </div>
        </div>
        <div class="pb-3">
          <simple-label :label="i18n.ftp.host"></simple-label>
          <text-copier
            :message="download.ftp.server"
            class="text-sm"
          ></text-copier>
        </div>
      </div>
    </div>
  </div>
  <alert
    v-else-if="!project.hasFramesToDownload"
    :message="$store.state.dashboard.i18n.project.errors.no_available_frames"
    level="info"
    class="px-5 py-2 my-2"
  />
  <safe-warning v-else :label="i18n.safe_warning" />
</template>

<script>
import RanchsyncButton from "../RanchsyncButton";

export default {
  props: ["project"],
  components: { RanchsyncButton },
  computed: {
    i18n() {
      return this.$store.state.dashboard.i18n.project.modals.download;
    },

    download() {
      return (
        this.project.hasFramesToDownload &&
        this.project.routes &&
        this.project.routes.download
      );
    },

    ranchsyncs() {
      return this.$store.state.app.ranchsync;
    },
  },
};
</script>
